import styled from '@emotion/styled';
import { Input } from '@qga/roo-ui/components';
import { themeGet } from '@styled-system/theme-get';
import { InputProps } from './types';

export const CheckOutInput = styled(Input)<InputProps>`
  border-radius: 0 4px 4px 0;
  border-left: none;
  cursor: pointer;
  border-color: ${(props) => themeGet(props.focused ? 'colors.brand.secondary' : 'colors.greys.alto')(props)};

  &:focus {
    border-color: ${(props) => themeGet(props.focused ? 'colors.brand.secondary' : 'colors.greys.alto')(props)};
  }
`;
